<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Areas de los centros</h4>
        <button type="button" class="btn btn-primary" routerLink="/addareacenter">Asignar nuevo area a un centro</button>
    </div>

    <table *ngIf="listAreaCenters.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre Area</th>
            <th scope="col">Nombre Centro</th>
            <th scope="col">Turno</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listAreaCenters" class="table-active">
            <td>{{ item.namearea }}</td>
            <td>{{ item.namecenter }}</td>
            <td>{{ item.nameturn }}</td>
            <td>
                <button routerLink="/editareacenter/{{item.id}}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteAreaCenter(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listAreaCenters.length == 0">No hay Areas de los centros para mostrar</h5>
</div>
